// src/pages/Automation.js 
// (Assuming this file contains your Automation component)

import React from 'react';
import { Helmet } from 'react-helmet-async'; // 👈 Import the Helmet component

// Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar';
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';

// Page Component
import AutomationContent from './PageComponent/AutomationContent'

function Automation() {

    // The useMeta hook call is removed and its content is moved into <Helmet>
    return (
        <>
            <Helmet>
                {/* Primary SEO Tags */}
                <title>With Smart Blinds Control light & privacy with press of remote or phone</title>
                <meta
                    name="description"
                    content="Marvel Blinds believe is accessing the high end automation systems in the Smart Blinds for easy and swift light control & make life easier"
                />
                <link rel="canonical" href={`${process.env.REACT_APP_WEBSITE_URL}/automation/`} />

                {/* Open Graph Tags (for Social Media) */}
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="Automation Solution" />
                <meta
                    property="og:description"
                    content="Marvel Blinds believe is accessing the high end automation systems in the Smart Blinds for easy and swift light control & make life easier"
                />
                <meta property="og:url" content={`${process.env.REACT_APP_WEBSITE_URL}/automation/`} />
                <meta property="og:site_name" content="Marvel Blinds" />
            </Helmet>

            {/* Rest of your component structure */}
            <div>
                <Navbar />
                <NotificationBar />
                <AutomationContent />
                <Footer />
            </div>
        </>
    );
}

export default Automation;